import { useTranslation } from "@opendash/i18n";
import {
  Button,
  Card,
  Checkbox,
  Form,
  FormInstance,
  FormListFieldData,
  FormListOperation,
  Input,
  Select,
  Typography,
} from "antd";
import { observer } from "mobx-react-lite";
import React from "react";

const { Text } = Typography;

type Props = {
  field: FormListFieldData;
  operation: FormListOperation;
  index: number;
  form: FormInstance;
};

export default observer((props: Props) => {
  const t = useTranslation();
  const [reload, setReload] = React.useState(false); // needed to get the updated field values to show onlyOneAllowedValue checkbox

  const hasAllowedValues =
    props.form?.getFieldValue("metafields")[props.index]?.allowedValues
      ?.length > 0;

  return (
    <Card
      type="inner"
      size="small"
      style={{ marginBottom: "8px" }}
      actions={[
        <Button
          key="delete"
          onClick={() => props.operation.remove(props.index)}
          danger
        >
          {t("maintenance:global.button.delete_label")}
        </Button>,
      ]}
    >
      <Form.Item
        initialValue={""}
        name={[props.field.name, "label"]}
        required
        label={
          <Text>
            {t("maintenance:admin.general.schedule.meta.item.label.label")}
          </Text>
        }
      >
        <Input />
      </Form.Item>
      <Form.Item
        initialValue={[]}
        name={[props.field.name, "allowedValues"]}
        label={
          <Text>
            {t(
              "maintenance:admin.general.schedule.meta.item.label.allowedValues"
            )}
          </Text>
        }
      >
        <Select
          allowClear
          mode="tags"
          onChange={() => setReload((prev) => !prev)}
        />
      </Form.Item>

      {hasAllowedValues && (
        <Form.Item
          initialValue={false}
          name={[props.field.name, "onlyOneAllowedValue"]}
          label={
            <Text>
              {t(
                "maintenance:admin.general.schedule.meta.item.label.onlyOneAllowedValue"
              )}
            </Text>
          }
          valuePropName="checked"
          layout="horizontal"
        >
          <Checkbox />
        </Form.Item>
      )}
      <Form.Item
        layout="horizontal"
        initialValue={false}
        name={[props.field.name, "required"]}
        label={
          <Text>
            {t("maintenance:admin.general.schedule.meta.item.label.required")}
          </Text>
        }
        valuePropName="checked"
      >
        <Checkbox />
      </Form.Item>
    </Card>
  );
});
